import { FadeUp } from "@/components/Reveal";
import { ASSETS } from "@/data/site";

const CHAPTERS = [
  {
    n: "01",
    title: "Slow is the way",
    text: "Healing cannot be hurried. We move at the pace of the body — long mornings, unhurried feeds, afternoons that belong to sleep.",
  },
  {
    n: "02",
    title: "Warmth is medicine",
    text: "Warm food, warm hands, warm rooms. For centuries every tradition agreed: a new mother must be kept warm, inside and out.",
  },
  {
    n: "03",
    title: "Mother the mother",
    text: "Everyone gathers around the baby. We gather around you — because a held mother becomes a mother who can hold.",
  },
  {
    n: "04",
    title: "Rest is sacred",
    text: "Lying in is not laziness; it is the oldest prescription on earth. We guard your rest the way grandmothers always did.",
  },
];

export default function Manifesto() {
  return (
    <section id="philosophy" className="bg-cream py-24 lg:py-32" data-testid="manifesto-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 items-end gap-12 lg:grid-cols-12">
          <FadeUp className="lg:col-span-7">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-sienna">Our philosophy</p>
            <h2 className="mt-5 max-w-2xl font-serif text-4xl font-light leading-tight text-espresso sm:text-5xl lg:text-6xl">
              Four things we <span className="italic text-sienna">believe</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.15} className="lg:col-span-4 lg:col-start-9">
            <div className="overflow-hidden rounded-xl border border-espresso/15" data-testid="manifesto-image">
              <img
                src={ASSETS.handsOnWomb}
                alt="Warm hands resting gently on a pregnant belly"
                className="aspect-[3/2] w-full object-cover"
              />
            </div>
            <p className="mt-3 text-center text-xs font-medium uppercase tracking-[0.2em] text-cocoa/60">
              Warm hands, chapter two
            </p>
          </FadeUp>
        </div>

        <div className="mt-16">
          {CHAPTERS.map((c, i) => (
            <FadeUp key={c.n} delay={0.05 * i}>
              <div className="grid grid-cols-1 gap-4 border-t border-espresso/15 py-10 lg:grid-cols-12 lg:gap-8" data-testid={`manifesto-chapter-${c.n}`}>
                <span className="font-serif text-6xl font-extralight text-mauve lg:col-span-3 lg:text-7xl">{c.n}</span>
                <h3 className="font-serif text-3xl font-medium text-espresso lg:col-span-4 lg:text-4xl">{c.title}</h3>
                <p className="max-w-xl text-base leading-relaxed text-cocoa lg:col-span-5">{c.text}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
